



































import { Component, mixins } from '@niknevis/vue-modules'
import { Prop, ProvideReactive } from 'vue-property-decorator'
import TesTable from '@/modules/common/tes-table/components/shared/TesTable.vue'
import Pagination from '@/modules/shared/components/shared/pagination/Pagination.vue'
import { QsPaginatableMixin } from '@/modules/shared/mixins/qs-paginatable.mixin'
import { QsSearchableMixin } from '@/modules/shared/mixins/qs-searchable.mixin'
import QTable from 'quasar/src/components/table/QTable.js';
import FilterRow from '@/modules/common/filter/components/shared/layout/FilterRow.vue'
import { DatePresetTypes, Filter, FilterTypes } from '@/modules/common/filter/filter'
import BaseButton from '@/modules/shared/components/shared/kit/BaseButton.vue'
import PanelInvoiceTableRow from '@/modules/invoice/components/panel/table/PanelInvoiceTableRow.vue'
import DateTooltipped from '@/modules/shared/components/shared/utils/DateTooltipped.vue'
import { PanelInvoiceRoute } from '@/modules/invoice/routes/panel-invoice.route'
import PanelLayout from '@/modules/common/layout/components/panel/PanelLayout.vue'
import { InvoiceCollectionTypeDefault } from '@/modules/invoice/models/invoice-collection.model'
import collect from 'collect.js'
import { getInvoiceColumns } from '@/modules/invoice/models/columns/invoice.column'
import TableExportButton from '@/modules/common/table-export/components/TableExportButton.vue'

@Component({
  layout: PanelLayout,
  layoutProps: {
    page_header: 'لیست فاکتورها',
    page_sub_header: 'لیست فاکتورهای ثبت شده در سیستم'
  },
  metaInfo: {
    title: 'لیست فاکتورها'
  },
  components: { TableExportButton, DateTooltipped, BaseButton, FilterRow, TesTable, Pagination }
})
export default class InvoiceIndex extends mixins(QsPaginatableMixin, QsSearchableMixin) {
  constructor(
    private readonly routes: PanelInvoiceRoute
  ) {
    super()
  }

  @ProvideReactive()
  @Prop() invoices!: InvoiceCollectionTypeDefault

  private rowComponent = PanelInvoiceTableRow

  private invoiceColumns: QTable['columns'] = getInvoiceColumns(false)

  private filters = [
    new Filter({
      type: FilterTypes.DateRange,
      holder: 'بازه دلخواه',
      typeMode: false,
      presets: [
        DatePresetTypes.today,
        DatePresetTypes.currentWeek,
        DatePresetTypes.currentMonth,
        DatePresetTypes.lastMonth,
        DatePresetTypes.last7Days,
        DatePresetTypes.custom
      ],
      title: 'بازه زمانی',
      keys: {
        from: 'paid_at_from',
        to: 'paid_at_to'
      }
    }),
    new Filter({
      type: FilterTypes.Select,
      title: 'مدل فاکتور',
      key: 'model_type',
      holder: 'انتخاب کنید',
      typeMode: false,
      items: collect(this.invoices.model_types)
        .map((item, index) => ({
          label: item,
          value: index
        })).toArray()
    }),
    new Filter({
      type: FilterTypes.Select,
      title: 'نوع فاکتور',
      key: 'person_type',
      holder: 'انتخاب کنید',
      typeMode: false,
      items: collect(this.invoices.person_types)
        .map((item, index) => ({
          label: item,
          value: index
        })).toArray()
    }),
    new Filter({
      type: FilterTypes.Select,
      title: 'وضعیت',
      key: 'status',
      holder: 'انتخاب کنید',
      typeMode: false,
      items: collect(this.invoices.statuses)
        .map((item, index) => ({
          label: item,
          value: index
        })).toArray()
    })
  ]

  numberOfPages() {
    return Math.ceil(this.pagination.rowsNumber / this.pagination.rowsPerPage)
  }

  updatePage(page: number) {
    this.updateTable({
      pagination: {
        ...this.pagination,
        page
      }
    })
  }

  protected get model() {
    return this.invoices
  }

}
